﻿(function () {
    'use strict';

    var serviceId = 'logger';

    angular.module('app.common')
           .factory(serviceId, ['$log', logger]);

    function logger($log) {
        var factory = {
            NotyInfo: notyInfo,
            NotyError: notyError,
            NotySuccess: notySuccess,
            NotyWarning: notyWarning,
            Log: log,
            LogInfo: logInfo,
            LogWarn: logWarn,
            LogError: logError,
            debug: logDebug,
        };

        return factory;

        function log(message) {
            logMsg(message);
        }

        function logInfo(message) {
            logMsg(message, 'info');
        }

        function logWarn(message) {
            logMsg(message, 'warn');
        }

        function logError(message) {
            logMsg(message, 'error');
        }
        
        function logDebug(message) {
            logMsg(message, 'debug');
        }

        function logMsg(message, type) {
            if (type === 'info') {
                $log.info(message);
            } else if (type === 'warn') {
                $log.warn(message);
            } else if (type === 'error') {
                $log.error(message);
            } else if (type === 'debug') {
                $log.debug(message);
            } else {
                $log.log(message);
            }
        }

        function notyInfo(message) {
            notyMsg(message, 'info');
        }

        function notyWarning(message) {
            notyMsg(message, 'warning');
        }

        function notySuccess(message) {
            notyMsg(message, 'success');
        }

        function notyError(message) {
            notyMsg(message, 'error');
        }
        
        function notyMsg(message, type)
        {
            if (type === 'error') {
                toastr.error(message);
            } else if (type === 'warning') {
                //toastr.warning(message);
            } else if (type === 'success') {
                //toastr.success(message);
            } else {
                //toastr.info(message);
            }
        }

    }
})();